import { FunctionComponent } from "react";
import styles from "./Tab.module.scss";

export interface TabLabelProps {
  active?: boolean;
  children: any;
  classes?: string;
  disabled?: boolean;
  onClick: () => void;
}

export const TabLabel: FunctionComponent<TabLabelProps> = ({
  active,
  children,
  classes,
  disabled = false,
  onClick: clickHandler,
}) => {
  return (
    <div
      className={`${styles.tab} ${classes ? classes : ""} ${
        active ? "active" : ""
      }`}
      tabIndex={disabled ? undefined : 0}
      onClick={disabled ? undefined : () => clickHandler()}
      onKeyDown={
        disabled
          ? undefined
          : (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                clickHandler();
              }
            }
      }
    >
      {children}
    </div>
  );
};
